export const LanguageType = {
    en: 1,
    ja: 2,
    cn: 3,
    tc: 4,
    ko: 5,
    vi: 6,
    id: 7,
    pt: 8,
    es: 9,
}

export function getLanguageValue(key) {
    return LanguageType[key];
}

export const LanguageCode = {
    1: "en",
    2: "ja",
    3: "cn",
    4: "tc",
    5: "ko",
    6: 'vi',
    7: 'id',
    8: 'pt',
    9: 'es',
}


export function getPropByLanguage(lan) {
    if (lan === "ja") return "jp";
    if (lan === "en") return "english";
    if (lan === "cn") return "cn";
    if (lan === "ko") return "ko";
    if (lan === "tc") return "tc";
    if (lan === "vi") return "vi";
    if (lan === "id") return "id";
    if (lan === "pt") return "english";
    if (lan === "es") return "english";
}